<form *ngIf="form" [formGroup]="form">
  <ng-template #occupation>
    <label for="float-input-masters-examination" class="ui-g-3 field-label text-right-align required">
      {{ 'basic-profile.fields.occupation-concession' | translate }}
    </label>
    <p-dropdown [options]="occupationOptions" id="float-input-masters-examination" formControlName="occupation" [disabled]="readonly">
      <ng-template let-item pTemplate="selectedItem">
        <span class="drop-item-label">{{ 'app.drop_down.' + item['label'] | translate }}</span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="drop-item">
          <span class="drop-item-label">{{ 'app.drop_down.' + option['label'] | translate }}</span>
        </div>
      </ng-template>
    </p-dropdown>
  </ng-template>

  <ng-template #weldingLicense>
    <label class="ui-g-5 required">
      {{ 'basic-profile.fields.welding-license' | translate }}
    </label>
    <div class="ui-g-1 margin-align">
      <p-radioButton
        formControlName="hasWeldingLicense"
        name="license"
        [value]="true"
        [label]="'yes-button-label' | translate"
        [disabled]="readonly"></p-radioButton>
    </div>
    <div class="ui-g-1 margin-align">
      <p-radioButton
        formControlName="hasWeldingLicense"
        name="license"
        [value]="false"
        [label]="'no-button-label' | translate"
        [disabled]="readonly"></p-radioButton>
    </div>
  </ng-template>

  <app-review-section
    [title]="'basic-profile.fields.data-concession-validaiton' | translate"
    [showAcceptRejectButtons]="false"
    [showMessages]="false"></app-review-section>
  <div>
    <!-- OCCUPATION -->
    <div class="ui-g-6 margin-align" *ngIf="scenario === 'Manual' && !isGuestTechnician">
      <ng-template [ngTemplateOutlet]="occupation"></ng-template>
    </div>

    <!-- REGISTERED COMODITIES -->
    <div class="ui-g-12 margin-align" *ngIf="scenario === 'Manual'">
      <label class="ui-g-3 required">
        {{ 'basic-profile.fields.registered-commodities' | translate }}
      </label>
      <div *ngFor="let commodity of comodities; let i = index" [formGroup]="form.controls['registeredCommodities']">
        <div class="ui-g-2 margin-align">
          <p-checkbox
            appEnterClick
            [formControlName]="commodity"
            [value]="true"
            id="details-checkbox-{{ i }}"
            binary="true"
            label="{{ 'overview.details-data.data-rows.' + commodity | translate }}"
            (onChange)="changeCommodity(commodity, $event)"
            [disabled]="readonly"></p-checkbox>
        </div>
      </div>
    </div>

    <!-- WELDING LICENSE -->
    <div class="ui-g-12" *ngIf="scenario === 'Manual' && (!isGuestTechnician || isManualHeatingCommodity)">
      <ng-template [ngTemplateOutlet]="weldingLicense"></ng-template>
    </div>

    <!-- BDEW ID YES NO -->
    <div class="ui-g-12" *ngIf="scenario === 'Mixed'">
      <label class="ui-g-5 required" for="hasBdewId">
        {{ 'basic-profile.fields.do-you-have-bdew-id' | translate }}
      </label>
      <div class="ui-g-1 margin-align">
        <p-radioButton
          name="hasBdewId"
          [value]="true"
          [label]="'yes-button-label' | translate"
          formControlName="hasBdewId"
          [disabled]="readonly"></p-radioButton>
      </div>
      <div class="ui-g-1 margin-align">
        <p-radioButton
          name="hasBdewId"
          [value]="false"
          [label]="'no-button-label' | translate"
          formControlName="hasBdewId"
          [disabled]="readonly"></p-radioButton>
      </div>
    </div>

    <!-- DO YOU WANT TO REGISTER FOR DISTRICT HEATING CONCESSION -->
    <div class="ui-g-12" *ngIf="scenario === 'Mixed' && showConcessionDistrictHeating">
      <label class="ui-g-5 required" for="isRegisterForDistrictHeating">
        {{ 'basic-profile.fields.do-you-reg-distr-heating-concession' | translate }}
      </label>
      <div class="ui-g-1 margin-align">
        <p-radioButton
          name="isRegisterForDistrictHeating"
          [value]="true"
          [label]="'yes-button-label' | translate"
          formControlName="isRegisterForDistrictHeating"
          [disabled]="readonly"></p-radioButton>
      </div>
      <div class="ui-g-1 margin-align">
        <p-radioButton
          name="isRegisterForDistrictHeating"
          [value]="false"
          [label]="'no-button-label' | translate"
          formControlName="isRegisterForDistrictHeating"
          [disabled]="readonly"></p-radioButton>
      </div>
    </div>

    <!-- BDEW TECHNICIAN ID -->
    <div class="ui-g-12 mt-1" *ngIf="scenario === 'Mixed' && form.controls['hasBdewId'].value">
      <label for="bdew-technician-id" class="ui-g-3 required">{{ 'basic-profile.fields.bdew-technician-id' | translate }}</label>
      <input
        id="bdew-technician-id"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="bdewTechnicianId"
        [attr.disabled]="readonly || null" />
      <div class="info-icon">
        <button
          pButton
          [label]="'technical-data.check-id' | translate"
          [disabled]="!form.controls['bdewTechnicianId'].valid"
          (click)="loadTechnicianDetails(form)"></button>
        <i
          class="pi pi-info-circle hint-icon"
          tooltipStyleClass="netz-info-tooltip"
          pTooltip="{{ 'basic-profile.fields.bdew-technician-id-info' | translate }}"></i>
      </div>
    </div>

    <!-- OCCUPATION -->
    <div
      class="ui-g-12 mt-1 margin-align"
      *ngIf="scenario === 'Mixed' && showConcessionDistrictHeating && form.controls['isRegisterForDistrictHeating'].value">
      <ng-template [ngTemplateOutlet]="occupation"></ng-template>
    </div>

    <div class="ui-g-12 automatic-data-container" *ngIf="scenario === 'Mixed' && form.controls['hasBdewId'].value">
      <p-progressSpinner id="concession-registration-details-spinner" *ngIf="isConcessionRegistrationDetailsLoading"></p-progressSpinner>

      <ng-container *ngIf="!isConcessionRegistrationDetailsLoading && form.controls['concessionRegistrationDetails'].value">
        <div class="ui-sm-12 ui-g-6">
          <label for="auto-technician-role" class="ui-g-5">{{ 'basic-profile.fields.technician-role' | translate }}</label>
          <input
            id="auto-technician-role"
            type="text"
            size="30"
            pInputText
            class="h4-button-and-field ui-input pInputText filed-width"
            disabled
            [value]="form.controls['concessionRegistrationDetails'].value.technicianRole | translate" />
        </div>

        <div class="ui-sm-12 ui-g-6">
          <label for="auto-registered-comodities" class="ui-g-5">{{ 'basic-profile.fields.registered-commodities' | translate }}</label>
          <input
            id="auto-registered-comodities"
            type="text"
            size="30"
            pInputText
            class="h4-button-and-field ui-input pInputText filed-width"
            disabled
            [value]="getRegisteredCommodities()" />
        </div>

        <div class="ui-sm-12 ui-g-6">
          <label for="auto-registered-comodities" class="ui-g-5">{{ 'basic-profile.fields.concession-valid-until' | translate }}</label>
          <input
            id="auto-registered-comodities"
            type="text"
            size="30"
            pInputText
            class="h4-button-and-field ui-input pInputText filed-width"
            disabled
            [value]="form.controls['concessionRegistrationDetails'].value.validUntil | date : dateFormat" />
        </div>
      </ng-container>
    </div>

    <div
      class="ui-g-12 margin-align mt-1"
      *ngIf="scenario === 'Mixed' && showConcessionDistrictHeating && form.controls['isRegisterForDistrictHeating'].value">
      <ng-template [ngTemplateOutlet]="weldingLicense"></ng-template>
    </div>
  </div>
</form>
